module.exports = __webpack_public_path__ + "img/unlock-red-rectangle-flat.a2cc30bf.png";